export enum ReportType {
    Undefined = 0,
    Contact = 1,
    Event = 2,
    Invitation = 3,
    Venue = 4,
}


export enum ReportFolderType {
    Undefined = 0,
    Public = 1,
    Private = 2
}
